import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_ExternalModal = _resolveComponent("ExternalModal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      class: "external-link pointer",
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.openModal && $options.openModal(...args)))
    }, [
      _createVNode(_component_Ellipsis, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.href), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(_component_ExternalModal, {
      ref: "modal",
      href: $props.href
    }, null, 8 /* PROPS */, ["href"])
  ], 64 /* STABLE_FRAGMENT */))
}